import React, { useMemo } from 'react';

/**
 * TEMPORARY experiment: subtle sparks of light drifting from the bottom
 * of the viewport to the top. Rendered between the cover image and the
 * prayer text inside the immersive overlay. Pure CSS animations
 * (sparkRise / sparkSway keyframes in App.css), pointer-events: none.
 */
const SPARK_COUNT = 26;

const Sparks = ({ speed = 1 }) => {
  // Site-wide speed multiplier (admin setting). 1 = original pace;
  // 2 = twice as fast (rise duration halved).
  const s = Math.min(5, Math.max(0.1, Number(speed) || 1));
  const sparks = useMemo(() => Array.from({ length: SPARK_COUNT }, () => ({
    left: Math.random() * 100,
    size: 1.5 + Math.random() * 2.5,
    duration: (9 + Math.random() * 10) / s,
    delay: -(Math.random() * 19) / s,
    drift: (Math.random() * 2 - 1) * 70,
    sway: 3 + Math.random() * 4,
    peak: 0.3 + Math.random() * 0.45,
    warm: Math.random() < 0.65,
  })), [s]);

  return (
    <div
      className="absolute inset-0 overflow-hidden pointer-events-none"
      aria-hidden="true"
      data-testid="immersive-sparks-layer"
    >
      {sparks.map((s, i) => (
        <span
          key={i}
          className="absolute bottom-0"
          style={{
            left: `${s.left}%`,
            opacity: 0,
            animation: `sparkRise ${s.duration}s linear ${s.delay}s infinite`,
            '--spark-peak': s.peak,
            '--spark-drift': `${s.drift}px`,
          }}
        >
          <span
            style={{
              display: 'block',
              width: `${s.size}px`,
              height: `${s.size}px`,
              borderRadius: '9999px',
              background: s.warm ? 'rgba(255, 209, 102, 0.9)' : 'rgba(255, 255, 255, 0.85)',
              boxShadow: s.warm
                ? '0 0 6px 2px rgba(255, 190, 80, 0.45)'
                : '0 0 6px 2px rgba(255, 255, 255, 0.35)',
              animation: `sparkSway ${s.sway}s ease-in-out ${s.delay}s infinite alternate`,
            }}
          />
        </span>
      ))}
    </div>
  );
};

export default Sparks;
